import { DictionaryEntry } from "@sdbn/common";
import { MasterDetailListEntry } from "@sdbn/common";

export enum TerminalLoginType {
  ALWAYS = 'ALWAYS', DAILY = 'DAILY', ONCE = 'ONCE'
}

export class VisitorRole implements MasterDetailListEntry {

  id: number;

  name = new DictionaryEntry();

  allowYardEntranceByCar: boolean;
  allowYardEntranceOnFoot: boolean;
  allowOverrideRoleSettings: boolean;
  invitationRequiresConfirmation: boolean;
  invitationConfirmationOnAccessOnly: boolean;
  assignPrivilegesOnInvitation: boolean;
  requireTerminalLogin: boolean;
  requireTerminalLoginType: string;
  requireInstructionsDone: boolean;
  oneTimeVisit: boolean;
  validDaysCount: number;
  instructionValidDaysCount: number;
  showInTerminal: boolean;
  cleanupAfterHours: number;
  deleteAfterHours: number;
  includeRegistrationQRCodeInMail: boolean;
  icon: string;
  onlySecuredAccess: boolean;
  upfrontRegistrationMailBody: string;
  informationTexts = new Array<VisitorRoleInfoText>();
  tasks = new Array<VisitorRoleTask>();

  constructor(role?: any) {
    if (role != null) {
      this.id = role.id;
      this.name = new DictionaryEntry(role.name);
      this.allowYardEntranceByCar = role.allowYardEntranceByCar;
      this.allowYardEntranceOnFoot = role.allowYardEntranceOnFoot;
      this.allowOverrideRoleSettings = role.allowOverrideRoleSettings
      this.invitationRequiresConfirmation = role.invitationRequiresConfirmation
      this.invitationConfirmationOnAccessOnly = role.invitationConfirmationOnAccessOnly
      this.assignPrivilegesOnInvitation = role.assignPrivilegesOnInvitation
      this.requireTerminalLogin = role.requireTerminalLogin;
      this.requireTerminalLoginType = role.requireTerminalLoginType;
      this.requireInstructionsDone = role.requireInstructionsDone;
      this.oneTimeVisit = role.oneTimeVisit;
      this.validDaysCount = role.validDaysCount;
      this.instructionValidDaysCount = role.instructionValidDaysCount;
      this.showInTerminal = role.showInTerminal;
      this.cleanupAfterHours = role.cleanupAfterHours;
      this.deleteAfterHours = role.deleteAfterHours;
      this.includeRegistrationQRCodeInMail = role.includeRegistrationQRCodeInMail;
      this.icon = role.icon;
      this.onlySecuredAccess = role.onlySecuredAccess;
      this.upfrontRegistrationMailBody = role.upfrontRegistrationMailBody

      if (role.informationTexts != null) {
        for (let infotext of role.informationTexts) {
          this.informationTexts.push(new VisitorRoleInfoText(infotext));
        }
      }

      if (role.tasks != null) {
        for (let task of role.tasks) {
          this.tasks.push(new VisitorRoleTask(task));
        }
      }

    }

  }

  public get listTitle(): string {
    return null;
  }

  public get listTitleDictionaryKey(): string {
    return this.name.dictionaryKey;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs(): Array<MasterDetailListEntry> {
    return null;
  }
}

export class VisitorRoleInfoText {

  id: number;
  text = new DictionaryEntry();
  index: number;
  deleted: boolean;

  constructor(infoText: Partial<VisitorRoleInfoText>) {
    this.id = infoText?.id;
    this.text = new DictionaryEntry(infoText.text);
    this.index = infoText?.index;
    this.deleted = infoText?.deleted;
  }
}

export class VisitorRoleTask {

  id: number;
  name = new DictionaryEntry();
  validity: number;
  optional: boolean;
  deleted: boolean;

  constructor(task?: any) {
    if (task != null) {
      this.id = task.id;
      this.name = new DictionaryEntry(task.name);
      this.validity = task.validity;
      this.optional = task.optional;
    }
  }
}
